import React from "react";
import { ACCOUNTS } from "../../../model/accounting/Chart.js";
import { Column } from "../../../../packages/ui/table/quick/Column.js";
import { Account } from "../../../model/accounting/account/Account.js";
import { AccountLink } from "../account/AccountLink.js";
import { FixedTable } from "../../../../packages/ui/table/quick/FixedTable.js";

/**
 * Renders the table with all accounts in the system.
 */
export const AccountsTable = () => {
  const columns: Column<Account>[] = [
    {
      span: 3,
      title: "Kood",
      render: (row) => <AccountLink accountId={row.id} />
    },
    {
      span: 3,
      title: "Nimi",
      render: (row) => row.name
    },
    {
      span: 2,
      title: "Tüüp",
      render: (row) => row.type
    }
  ];

  return <FixedTable columns={columns} rows={ACCOUNTS} fontSize="tiny" />;
};
